/**
 * Collection & Boost integration
 *
 * - Quick-add capture for Boost search results and collection showcase cards
 * - Sorting dropdown viewport overflow fix on collection and search pages
 * - Mobile Filter toggle active-count label (Filter (2)) on collection/search
 * - Per-group selected counts on filter titles, and contrast-aware color checks
 * - Mobile drawer Reset / Apply bar. Reset clears now and is kept on close; Apply keeps current filters; X restores filters from when the drawer opened unless Reset was used
 * - Desktop Show/Hide Filters toggle; hides the sidebar and shows the applied count
 * - Toggle ae-toolbar-stuck once the sticky toolbar pins under the header
 * - On collection and search pages, keep the toolbar sticky and stop the page moving while the cart drawer is open
 * - Subcollection grid sync from Boost markup on collection pages
 * - Hydrate Boost card custom titles from ?view=review (custom.product_label → collection name)
 */

const PRODUCT_HANDLE_RE = /\/products\/([^/?#]+)/;

function normalizeProductHandle(handle) {
  if (!handle) return '';
  handle = String(handle).trim();
  const match = handle.match(PRODUCT_HANDLE_RE);
  if (match) return match[1];
  return handle.replace(/^\/+|\/+$/g, '');
}

(function () {
  if (window.collectionShowcaseCardsCaptureListenerAdded) return;
  window.collectionShowcaseCardsCaptureListenerAdded = true;

  function resolveProductHandle(btn) {
    let handle = normalizeProductHandle(
      btn.getAttribute('data-product-handle') || btn.dataset.productHandle,
    );
    if (handle) return handle;

    const scope = btn.closest(
      '.boost-sd__product-item, .boost-sd__suggestion-queries-item-product, .product-collection-showcase__card',
    );
    if (scope) {
      handle = normalizeProductHandle(
        scope.getAttribute('data-product-handle') || scope.dataset.productHandle,
      );
      if (handle) return handle;

      const productData = scope.getAttribute('data-product');
      if (productData) {
        try {
          const parsed = JSON.parse(productData);
          if (parsed && parsed.handle) return normalizeProductHandle(parsed.handle);
        } catch (err) {}
      }
    }

    const link =
      btn.closest('a[href*="/products/"]') ||
      (scope && scope.querySelector('a.boost-sd__product-link[href], a[href*="/products/"]'));
    if (link) {
      const hrefMatch = link.getAttribute('href').match(PRODUCT_HANDLE_RE);
      if (hrefMatch) return hrefMatch[1];
    }

    return '';
  }

  function closeBoostSearchDrawer() {
    if (window.aePredictiveSearch && typeof window.aePredictiveSearch.closeDrawer === 'function') {
      window.aePredictiveSearch.closeDrawer();
      return;
    }

    const drawer = document.getElementById('AeSearchDrawer');
    const overlay = document.querySelector('.ae-drawer-overlay');
    if (drawer) {
      drawer.classList.remove('is-active');
      drawer.style.display = 'none';
    }
    if (overlay) {
      overlay.classList.remove('is-active');
      overlay.style.display = 'none';
    }
    document.querySelectorAll('.js-search-header-custom').forEach((trigger) => {
      trigger.classList.remove('is-active');
    });
    document.body.style.overflow = '';
    document.body.classList.remove('boost-sd__search-opening');
    const boostWrapper = document.getElementById('boost-sd__search-widget-init-wrapper');
    if (boostWrapper) {
      boostWrapper.classList.add('boost-sd__g-hide');
    }
  }

  window.closeAeSearchDrawer = closeBoostSearchDrawer;

  function openQuickAdd(btn) {
    const prefetched =
      typeof window.parseQuickAddProductFromButton === 'function'
        ? window.parseQuickAddProductFromButton(btn)
        : null;
    const handle =
      normalizeProductHandle(btn.getAttribute('data-product-handle') || btn.dataset.productHandle) ||
      (prefetched && prefetched.handle) ||
      resolveProductHandle(btn);
    const productId = btn.getAttribute('data-product-id') || (prefetched && prefetched.id);

    if (!handle) return;

    if (typeof window.openQuickAddModalProductCards === 'function') {
      window.openQuickAddModalProductCards(handle, productId, prefetched, btn);
      return;
    }

    // Modal script can lag Boost's first paint — retry briefly instead of
    // navigating away (that felt like a white-screen reload on first ATC).
    let attempts = 0;
    const retryId = window.setInterval(function () {
      attempts += 1;
      if (typeof window.openQuickAddModalProductCards === 'function') {
        window.clearInterval(retryId);
        window.openQuickAddModalProductCards(handle, productId, prefetched, btn);
        return;
      }
      if (attempts >= 20) {
        window.clearInterval(retryId);
        closeBoostSearchDrawer();
      }
    }, 100);
  }

  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest(
        [
          '.boost-sd__product-item .boost-sd__button',
          '.boost-sd__suggestion-queries-item-product .boost-sd__button',
          '.boost-sd__suggestion-queries-item--product .boost-sd__button',
          '.boost-sd__suggestion-queries-item--product [class*="__card-add-to-cart"]',
          '[class*="__card-add-to-cart"][data-quick-add-product]',
          '.boost-sd__product-item [class*="__card-add-to-cart"]',
        ].join(', '),
      );
      if (!btn || btn.disabled) return;
      if (btn.id === 'QuickAddModalProductCardsAddToCart') return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      openQuickAdd(btn);
    },
    true,
  );
})();

// (() => {
//   const path = window.location.pathname;
//   if (!path.startsWith('/collections/') && !path.startsWith('/search')) return;

//   document.addEventListener('click', (e) => {
//     if (!e.target.closest('.boost-sd__sorting-button')) return;

//     const dropdown = document.querySelector('.boost-sd__sorting-list');
//     if (!dropdown) return;

//     dropdown.style.transform = 'translateY(0px)';

//     setTimeout(() => {
//       const rect = dropdown.getBoundingClientRect();
//       const overflow = rect.bottom - window.innerHeight;
//       if (overflow > 0) {
//         dropdown.style.transform = `translateY(-${overflow + 10}px)`;
//       }
//     }, 100);
//   });
// })();

(() => {
  // Show active filter count on the mobile Filter toggle: Filter (2)
  const path = window.location.pathname;
  if (!path.startsWith('/collections/') && !path.startsWith('/search')) return;

  const TOGGLE_SELECTOR = '.boost-sd__filter-tree-toggle-button';
  const TEXT_SELECTOR = '.boost-sd__filter-tree-toggle-button-text';
  const REFINE_ITEM_SELECTOR = '.boost-sd__refine-by-vertical-refine-by-item';
  const COUNT_SUFFIX_RE = /\(\d+\)$/;
  const GROUP_ARIA_SUFFIX_RE = /, \d+ selected$/;
  /** White check, same as on a black swatch. Add color names here. */
  const WHITE_CHECK_COLORS = [
    'black',
    'gray',
    'grey',
    'blue',
    'camo',
    'green',
    'brown',
    'red',
    'orange',
    'purple',
    'khaki',
    'teal',
  ];

  /** Black check, for light swatches. Add color names here. */
  const BLACK_CHECK_COLORS = [
    'white',
    'ivory',
    'cream',
    'beige',
    'silver',
    'natural',
    'sand',
    'bone',
    'champagne',
    'off-white',
    'off white',
    'light gray',
    'light grey',
    'yellow',
    'pink',
    'tan',
    'gold',
  ];

  /**
   * @param {number} channel
   * @returns {number}
   */
  function linearize(channel) {
    const value = channel / 255;
    if (value <= 0.03928) return value / 12.92;
    return ((value + 0.055) / 1.055) ** 2.4;
  }

  /**
   * @param {string} color
   * @returns {{ r: number, g: number, b: number, a: number } | null}
   */
  function parseRgb(color) {
    const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (!match) return null;

    return {
      r: Number(match[1]),
      g: Number(match[2]),
      b: Number(match[3]),
      a: match[4] === undefined ? 1 : Number(match[4]),
    };
  }

  /**
   * White check fails WCAG 3:1 non-text contrast below this ratio.
   * @param {number} r
   * @param {number} g
   * @param {number} b
   * @returns {boolean}
   */
  function needsDarkCheck(r, g, b) {
    const luminance = (0.2126 * linearize(r)) + (0.7152 * linearize(g)) + (0.0722 * linearize(b));
    const contrast = 1.05 / (luminance + 0.05);
    return contrast < 3;
  }

  /**
   * Checked options inside one filter group. Swatches and lists both use a --selected class.
   * @param {Element} option
   * @returns {number}
   */
  function getOptionSelectedCount(option) {
    const selectedItems = new Set();

    for (const node of option.querySelectorAll('[class*="--selected"], [aria-pressed="true"], [aria-checked="true"]')) {
      if (!(node instanceof Element)) continue;
      if (node.closest('.boost-sd__filter-option-title')) continue;

      selectedItems.add(node.closest('li, .boost-sd__filter-option-item') || node);
    }

    for (const input of option.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked')) {
      selectedItems.add(input.closest('li, .boost-sd__filter-option-item') || input);
    }

    return selectedItems.size;
  }

  /**
   * Same pattern as the Hide Filters label, scoped to this group's checked options.
   * The count is its own span so Boost can keep rewriting the name text.
   * @param {HTMLElement} title
   * @param {number} count
   */
  function setGroupTitleCount(title, count) {
    const labelSpan = title.querySelector(':scope > span:not(.ae-filter-selected-count)');
    if (!(labelSpan instanceof HTMLElement)) return;

    let badge = title.querySelector(':scope > .ae-filter-selected-count');
    const text = `(${count})`;

    if (count > 0) {
      if (!(badge instanceof HTMLElement)) {
        badge = document.createElement('span');
        badge.className = 'ae-filter-selected-count';
        badge.setAttribute('aria-hidden', 'true');
        labelSpan.after(badge);
      }

      if (badge.textContent !== text) badge.textContent = text;
    } else if (badge) {
      badge.remove();
    }
  }

  function updateFilterGroupCounts() {
    const options = document.querySelectorAll(
      '.boost-sd-left .boost-sd__filter-option, .boost-sd__filter-tree-vertical--fullWidth .boost-sd__filter-option',
    );

    for (const option of options) {
      if (!option.querySelector('.boost-sd__filter-option-item')) continue;

      const title = option.querySelector('.boost-sd__filter-option-title');
      if (!(title instanceof HTMLElement)) continue;

      const count = getOptionSelectedCount(option);
      setGroupTitleCount(title, count);

      const currentAria = title.getAttribute('aria-label') || '';
      const ariaBase = currentAria.replace(GROUP_ARIA_SUFFIX_RE, '').trim();
      const nextAria = count > 0 ? `${ariaBase}, ${count} selected` : ariaBase;

      if (ariaBase && title.getAttribute('aria-label') !== nextAria) {
        title.setAttribute('aria-label', nextAria);
      }
    }
  }

  function updateSwatchCheckContrast() {
    const selected = document.querySelectorAll('.boost-sd__filter-option-swatch-item-img--selected');

    for (const node of selected) {
      const swatch = node.classList.contains('boost-sd__filter-option-swatch-item-img')
        ? node
        : node.querySelector('.boost-sd__filter-option-swatch-item-img');
      const scope = node.closest('li') || node;
      const label = (scope.querySelector('.boost-sd__filter-option-item-label')?.textContent || '')
        .replace(/\s*\([^)]*\)/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
      const listedWhite = WHITE_CHECK_COLORS.includes(label);
      const listedBlack = BLACK_CHECK_COLORS.includes(label);
      let dark = listedBlack;

      const colorNode = swatch instanceof HTMLElement ? swatch : node;
      if (!listedWhite && !listedBlack && colorNode instanceof HTMLElement) {
        const parsed = parseRgb(getComputedStyle(colorNode).backgroundColor);
        if (parsed && parsed.a >= 0.5) {
          dark = needsDarkCheck(parsed.r, parsed.g, parsed.b);
        }
      }

      for (const target of [node, scope]) {
        if (!(target instanceof Element)) continue;
        if (target.classList.contains('ae-filter-check--dark') !== dark) {
          target.classList.toggle('ae-filter-check--dark', dark);
        }
      }
    }
  }

  /**
   * @returns {number}
   */
  function getActiveFilterCount() {
    const refineCount = document.querySelectorAll(REFINE_ITEM_SELECTOR).length;
    if (refineCount > 0) return refineCount;

    const params = new URLSearchParams(window.location.search);
    let count = 0;

    for (const [key, value] of params.entries()) {
      if (!key.startsWith('pf_') || !value) continue;

      // Range filters (e.g. price 10:50) count as one applied filter
      if (value.includes(':') && !value.includes(',')) {
        count += 1;
        continue;
      }

      count += value.split(',').filter(Boolean).length;
    }

    return count;
  }

  /**
   * @param {HTMLElement} textEl
   * @returns {string}
   */
  function getBaseLabel(textEl) {
    if (textEl.dataset.filterBaseLabel) return textEl.dataset.filterBaseLabel;

    const current = (textEl.textContent || '').trim().replace(COUNT_SUFFIX_RE, '').trim() || 'Filter';
    textEl.dataset.filterBaseLabel = current;
    return current;
  }

  const filterCopy = window.theme && window.theme.strings ? window.theme.strings : {};
  const filterResetLabel = filterCopy.filterReset || 'Reset';
  const filterApplyLabel = filterCopy.filterApply || 'Apply';
  const filterResetAriaLabel = filterCopy.filterResetLabel || 'Reset filters';
  const filterApplyAriaLabel = filterCopy.filterApplyLabel || 'Apply filters';
  const filterApplySelectedAriaLabel = filterCopy.filterApplySelectedLabel || 'Apply [count] selected filters';
  const filterShowLabel = filterCopy.filterShow || 'Show Filters';
  const filterHideLabel = filterCopy.filterHide || 'Hide Filters';

  const DRAWER_TREE_SELECTOR = '.boost-sd__filter-tree-vertical--fullWidth';
  const DRAWER_CLOSE_SELECTOR = '.boost-sd__filter-tree-vertical-mobile-toolbar .boost-sd__button--close';
  const DRAWER_CLEAR_SELECTOR = '#boost-sd__button-toolbar-mobile-clear';

  // Reset clears all filters immediately and is kept if the drawer is closed after.
  // Apply closes the drawer and keeps the current filters.
  // X / Escape discard filters chosen in this session and restore the URL from open,
  // unless Reset was used in that session.

  /** @type {string} */
  let drawerOpenHref = '';
  /** @type {Set<string>} */
  let drawerOpenSelectedKeys = new Set();
  let drawerHistoryDelta = 0;
  let restoringDrawerFilters = false;
  let cancellingFilterDrawer = false;
  let drawerResetCommitted = false;

  /**
   * @returns {boolean}
   */
  function isFilterDrawerOpen() {
    const tree = document.querySelector(DRAWER_TREE_SELECTOR);
    if (!(tree instanceof HTMLElement)) return false;
    return tree.getBoundingClientRect().height > 0;
  }

  /**
   * @param {string} href
   * @returns {string}
   */
  function getLocationKey(href) {
    try {
      const url = new URL(href, window.location.origin);
      return `${url.pathname}${url.search}`;
    } catch (err) {
      return href;
    }
  }

  /**
   * @param {Element} item
   * @returns {boolean}
   */
  function isFilterItemSelected(item) {
    if (item.matches('[class*="--selected"], [aria-pressed="true"], [aria-checked="true"]')) return true;
    if (item.querySelector('[class*="--selected"], [aria-pressed="true"], [aria-checked="true"]')) return true;
    return Boolean(item.querySelector('input[type="checkbox"]:checked, input[type="radio"]:checked'));
  }

  /**
   * @param {Element} item
   * @returns {string}
   */
  function getFilterItemKey(item) {
    const option = item.closest('.boost-sd__filter-option');
    const group = option instanceof HTMLElement
      ? option.id.replace(/-toggle-target$/, '')
      : '';
    const labelEl = item.querySelector('.boost-sd__filter-option-item-label');
    const label = ((labelEl && labelEl.textContent) || item.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();
    return `${group}::${label}`;
  }

  /**
   * @param {Element|null} root
   * @returns {Set<string>}
   */
  function getSelectedKeysFromRoot(root) {
    const keys = new Set();
    if (!(root instanceof HTMLElement)) return keys;

    for (const item of root.querySelectorAll('.boost-sd__filter-option-item')) {
      if (!isFilterItemSelected(item)) continue;
      keys.add(getFilterItemKey(item));
    }

    return keys;
  }

  /**
   * @returns {Set<string>}
   */
  function getDrawerSelectedKeys() {
    const keys = getSelectedKeysFromRoot(document.querySelector('.boost-sd-left'));

    for (const key of getSelectedKeysFromRoot(document.querySelector(DRAWER_TREE_SELECTOR))) {
      keys.add(key);
    }

    return keys;
  }

  function captureDrawerFilterState() {
    drawerOpenHref = window.location.href;
    drawerOpenSelectedKeys = getDrawerSelectedKeys();
    drawerHistoryDelta = 0;
    drawerResetCommitted = false;
  }

  /**
   * Uncheck options chosen after the drawer opened. Previously applied options stay.
   * @returns {boolean}
   */
  function deselectUnappliedFilterOptions() {
    const hadAppliedFilters = drawerOpenSelectedKeys.size > 0
      || /(?:\?|&)pf_/.test(drawerOpenHref);

    if (hadAppliedFilters && drawerOpenSelectedKeys.size === 0 && !drawerResetCommitted) {
      return false;
    }

    const tree = document.querySelector(DRAWER_TREE_SELECTOR);
    if (!(tree instanceof HTMLElement)) return false;

    let changed = false;

    for (const item of tree.querySelectorAll('.boost-sd__filter-option-item')) {
      if (!isFilterItemSelected(item)) continue;
      if (drawerOpenSelectedKeys.has(getFilterItemKey(item))) continue;

      const control = item.querySelector(
        'button, [role="button"], input[type="checkbox"], input[type="radio"]',
      );
      if (!(control instanceof HTMLElement)) continue;

      control.click();
      changed = true;
    }

    return changed;
  }

  function clickDrawerClose() {
    const close = document.querySelector(DRAWER_CLOSE_SELECTOR);
    if (close instanceof HTMLElement) close.click();
    window.setTimeout(updateMobileFilterToggle, 50);
  }

  function endDrawerCancel() {
    restoringDrawerFilters = false;
    cancellingFilterDrawer = false;
    clickDrawerClose();
  }

  /**
   * Restore filters from when the drawer opened, then close.
   * New unapplied selections are dropped; previously applied filters stay.
   */
  function closeDrawerAfterUnappliedDeselect() {
    restoringDrawerFilters = true;

    if (deselectUnappliedFilterOptions()) {
      window.setTimeout(endDrawerCancel, 150);
      return;
    }

    endDrawerCancel();
  }

  /**
   * Restore filters from when the drawer opened, then close.
   * New unapplied selections are dropped; previously applied filters stay.
   * Reset is kept: closing after Reset does not restore the pre-reset filters.
   */
  function cancelFilterDrawer() {
    if (cancellingFilterDrawer) return;
    cancellingFilterDrawer = true;

    if (drawerResetCommitted) {
      closeDrawerAfterUnappliedDeselect();
      return;
    }

    const snapshot = drawerOpenHref;
    const currentKey = getLocationKey(window.location.href);
    const snapshotKey = snapshot ? getLocationKey(snapshot) : currentKey;

    if (!snapshot || currentKey === snapshotKey) {
      closeDrawerAfterUnappliedDeselect();
      return;
    }

    restoringDrawerFilters = true;

    const finish = () => {
      drawerHistoryDelta = 0;
      endDrawerCancel();
    };

    const delta = drawerHistoryDelta;

    if (delta > 0 && delta < 50) {
      const onPop = () => {
        window.removeEventListener('popstate', onPop);
        window.clearTimeout(fallbackTimer);
        finish();
      };
      const fallbackTimer = window.setTimeout(() => {
        window.removeEventListener('popstate', onPop);

        if (getLocationKey(window.location.href) !== snapshotKey) {
          window.location.assign(snapshot);
          return;
        }

        finish();
      }, 600);

      window.addEventListener('popstate', onPop);
      window.history.go(-delta);
      return;
    }

    if (deselectUnappliedFilterOptions()) {
      window.setTimeout(finish, 150);
      return;
    }

    window.location.assign(snapshot);
  }

  let drawerWasOpen = false;

  function syncToolbarStack() {
    const open = isFilterDrawerOpen();

    if (open && !drawerWasOpen && !restoringDrawerFilters && !drawerOpenHref) {
      captureDrawerFilterState();
    }

    drawerWasOpen = open;

    const layouts = document.querySelectorAll('.boost-sd-layout');

    for (const layout of layouts) {
      if (layout.classList.contains('ae-filter-drawer-open') === open) continue;
      layout.classList.toggle('ae-filter-drawer-open', open);
    }
  }

  function updateDrawerActions() {
    const tree = document.querySelector(DRAWER_TREE_SELECTOR);
    if (!(tree instanceof HTMLElement)) return;

    let bar = tree.querySelector('.ae-filter-drawer-actions');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'ae-filter-drawer-actions';
      bar.innerHTML = [
        '<button type="button" class="ae-filter-drawer-actions__reset"></button>',
        '<button type="button" class="ae-filter-drawer-actions__apply"></button>',
      ].join('');
      tree.append(bar);
    }

    const reset = bar.querySelector('.ae-filter-drawer-actions__reset');
    if (reset instanceof HTMLButtonElement) {
      if (reset.textContent !== filterResetLabel) reset.textContent = filterResetLabel;
      if (reset.getAttribute('aria-label') !== filterResetAriaLabel) {
        reset.setAttribute('aria-label', filterResetAriaLabel);
      }
    }

    const apply = bar.querySelector('.ae-filter-drawer-actions__apply');
    if (!(apply instanceof HTMLButtonElement)) return;

    const count = getActiveFilterCount();
    const countLabel = `(${count})`;
    const aria = count > 0
      ? filterApplySelectedAriaLabel.replace('[count]', String(count))
      : filterApplyAriaLabel;
    let labelEl = apply.querySelector('.ae-filter-drawer-actions__label');
    let countEl = apply.querySelector('.ae-filter-drawer-actions__count');

    if (!(labelEl instanceof HTMLElement)) {
      apply.textContent = '';
      labelEl = document.createElement('span');
      labelEl.className = 'ae-filter-drawer-actions__label';
      labelEl.textContent = filterApplyLabel;
      apply.append(labelEl);
      countEl = null;
    }

    if (count > 0) {
      if (!(countEl instanceof HTMLElement)) {
        countEl = document.createElement('span');
        countEl.className = 'ae-filter-drawer-actions__count';
        apply.append(countEl);
      }

      if (countEl.textContent !== countLabel) countEl.textContent = countLabel;
    } else if (countEl) {
      countEl.remove();
    }

    if (apply.getAttribute('aria-label') !== aria) apply.setAttribute('aria-label', aria);
    apply.classList.toggle('ae-filter-drawer-actions__apply--empty', count === 0);
  }

  const DESKTOP_FILTER_STORAGE_KEY = 'aeDesktopFiltersHidden';
  const DESKTOP_FILTER_PAGE_KEY = 'aeDesktopFiltersPage';
  const DESKTOP_FILTER_MQ = window.matchMedia('(min-width: 992px)');
  let desktopFiltersHidden = false;

  try {
    const savedPage = sessionStorage.getItem(DESKTOP_FILTER_PAGE_KEY);
    if (savedPage === window.location.pathname) {
      desktopFiltersHidden = sessionStorage.getItem(DESKTOP_FILTER_STORAGE_KEY) === '1';
    } else {
      sessionStorage.setItem(DESKTOP_FILTER_STORAGE_KEY, '0');
      sessionStorage.setItem(DESKTOP_FILTER_PAGE_KEY, window.location.pathname);
    }
  } catch (err) {
    desktopFiltersHidden = false;
  }

  function ensureDesktopFilterButton() {
    if (filtersHaveSettled()) updateFilterGroupCounts();

    const sortControls = document.querySelectorAll('.boost-sd__sorting');
    const count = getActiveFilterCount();
    const actionLabel = desktopFiltersHidden ? filterShowLabel : filterHideLabel;
    const label = count > 0 ? `${actionLabel} (${count})` : actionLabel;
    const expanded = desktopFiltersHidden ? 'false' : 'true';

    for (const sortControl of sortControls) {
      if (!(sortControl instanceof HTMLElement)) continue;
      if (sortControl.closest('.boost-sd__filter-tree-vertical, .ae-desktop-filter-toggle')) continue;

      const host = sortControl.closest('.boost-sd__toolbar-item--sorting') || sortControl.parentElement;
      if (!(host instanceof HTMLElement)) continue;
      if (host.querySelector('.ae-desktop-filter-toggle')) continue;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ae-desktop-filter-toggle';
      button.innerHTML = [
        '<svg class="ae-desktop-filter-toggle__icon" xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none" aria-hidden="true" focusable="false">',
        '<g clip-path="url(#clip0_11989_55534)">',
        '<path d="M0.460475 2.64886H1.85149C2.06574 3.64291 2.98349 4.40324 4.06113 4.40324C5.13877 4.40324 6.06292 3.64291 6.27397 2.64886H17.4053C17.6515 2.64886 17.8658 2.4432 17.8658 2.20014C17.8658 1.95708 17.6547 1.75142 17.4053 1.75142H6.27078C6.05653 0.757375 5.13877 -0.00296021 4.06113 -0.00296021C2.98349 -0.00296021 2.06574 0.757375 1.85149 1.75142H0.460475C0.214249 1.75142 0 1.95708 0 2.20014C0 2.4432 0.211051 2.64886 0.460475 2.64886ZM4.06113 0.894484C4.80301 0.894484 5.40419 1.48032 5.40419 2.20326C5.40419 2.9262 4.80301 3.50891 4.06113 3.50891C3.31926 3.50891 2.71808 2.92308 2.71808 2.20326C2.71808 1.48343 3.31926 0.894484 4.06113 0.894484Z" fill="black"/>',
        '<path d="M17.4053 5.98607H14.78C14.5657 4.99202 13.648 4.23169 12.5703 4.23169C11.4927 4.23169 10.5749 4.99202 10.3607 5.98607H0.460475C0.214249 5.98607 0 6.19173 0 6.43479C0 6.67785 0.211051 6.88351 0.460475 6.88351H10.3575C10.5717 7.87756 11.4895 8.63789 12.5671 8.63789C13.6448 8.63789 14.5689 7.87756 14.78 6.88351H17.4053C17.6515 6.88351 17.8658 6.67785 17.8658 6.43479C17.8658 6.19173 17.6547 5.98607 17.4053 5.98607ZM12.5671 7.74045C11.8253 7.74045 11.2241 7.15462 11.2241 6.43167C11.2241 5.70873 11.8253 5.1229 12.5671 5.1229C13.309 5.1229 13.9102 5.70873 13.9102 6.43167C13.9102 7.15462 13.309 7.74045 12.5671 7.74045Z" fill="black"/>',
        '<path d="M17.4053 10.2521H6.27078C6.05653 9.25802 5.13877 8.49768 4.06113 8.49768C2.98349 8.49768 2.08493 9.22062 1.85789 10.2178H0.460475C0.214249 10.2178 0 10.4234 0 10.7008C0 10.9407 0.211051 11.1495 0.460475 11.1495H1.85149C2.06574 12.1435 2.98349 12.9039 4.06113 12.9039C5.13877 12.9039 6.0917 12.1435 6.28357 11.1495H17.4053C17.6515 11.1495 17.8658 10.9438 17.8658 10.7008C17.8658 10.4577 17.6547 10.2521 17.4053 10.2521ZM4.06113 12.0064C3.31926 12.0064 2.71808 11.4206 2.71808 10.6977C2.71808 9.97473 3.31926 9.38889 4.06113 9.38889C4.80301 9.38889 5.40419 9.97473 5.40419 10.6977C5.40419 11.4206 4.80301 12.0064 4.06113 12.0064Z" fill="black"/>',
        '</g>',
        '<defs><clipPath id="clip0_11989_55534"><rect width="17.8626" height="12.9008" fill="white"/></clipPath></defs>',
        '</svg>',
        '<span class="ae-desktop-filter-toggle__label"></span>',
      ].join('');

      const anchor = host.querySelector(':scope > .boost-sd__toolbar-top-mobile') || sortControl;
      host.insertBefore(button, anchor);

      const labelEl = button.querySelector('.ae-desktop-filter-toggle__label');
      if (labelEl) labelEl.textContent = label;
      button.setAttribute('aria-expanded', expanded);
      button.setAttribute('aria-controls', 'AeDesktopFilters');
    }

    const buttons = document.querySelectorAll('.ae-desktop-filter-toggle');
    for (const button of buttons) {
      const labelEl = button.querySelector('.ae-desktop-filter-toggle__label');
      if (labelEl && labelEl.textContent !== label) labelEl.textContent = label;
      if (button.getAttribute('aria-expanded') !== expanded) {
        button.setAttribute('aria-expanded', expanded);
      }
    }
  }

  /** @type {(() => void) | null} */
  let cancelDesktopFilterImageFit = null;
  let desktopFilterAnimating = false;
  let desktopFilterFitGeneration = 0;

  function fitDesktopProductImages() {
    if (typeof window.fitProductImageSwipers === 'function') {
      window.fitProductImageSwipers();
    }

    if (typeof window.setProductImageSwipersPaused === 'function') {
      window.setProductImageSwipersPaused(false);
    }
  }

  /**
   * Hand slide widths back to Swiper after the sidebar transition.
   * The fluid override stays up until that write, so there is no frame at the old pixel size.
   * @param {HTMLElement | null} sidebar
   */
  function scheduleDesktopProductImageFit(sidebar) {
    cancelDesktopFilterImageFit?.();
    desktopFilterFitGeneration += 1;
    const generation = desktopFilterFitGeneration;

    if (!(sidebar instanceof HTMLElement)) {
      desktopFilterAnimating = false;
      fitDesktopProductImages();
      document.querySelectorAll('.boost-sd-layout.ae-desktop-filters-animating').forEach((layout) => {
        layout.classList.remove('ae-desktop-filters-animating');
      });
      return;
    }

    let finished = false;
    let timer = 0;

    const finish = () => {
      if (finished || generation !== desktopFilterFitGeneration) return;

      finished = true;
      window.clearTimeout(timer);
      sidebar.removeEventListener('transitionend', onEnd);
      cancelDesktopFilterImageFit = null;

      try {
        fitDesktopProductImages();
      } finally {
        document.querySelectorAll('.boost-sd-layout.ae-desktop-filters-animating').forEach((layout) => {
          layout.classList.remove('ae-desktop-filters-animating');
        });
        desktopFilterAnimating = false;
      }
    };

    /**
     * @param {TransitionEvent} event
     */
    const onEnd = (event) => {
      if (event.propertyName !== 'margin-left') return;
      finish();
    };

    cancelDesktopFilterImageFit = () => {
      finished = true;
      window.clearTimeout(timer);
      sidebar.removeEventListener('transitionend', onEnd);
      cancelDesktopFilterImageFit = null;
    };

    sidebar.addEventListener('transitionend', onEnd);
    timer = window.setTimeout(finish, 400);
  }

  /**
   * @param {boolean} [deferImageFit]
   * @returns {HTMLElement | null}
   */
  function applyDesktopFilterClass(deferImageFit = false) {
    if (deferImageFit) desktopFilterAnimating = true;

    const layouts = document.querySelectorAll('.boost-sd-layout');
    /** @type {HTMLElement | null} */
    let sidebar = null;

    for (const layout of layouts) {
      layout.classList.toggle('ae-desktop-filters-hidden', desktopFiltersHidden);
      layout.classList.toggle('ae-desktop-filters-animating', deferImageFit || desktopFilterAnimating);

      const column = layout.querySelector('.boost-sd-left');
      if (!(column instanceof HTMLElement)) continue;

      if (column.id !== 'AeDesktopFilters') column.id = 'AeDesktopFilters';
      if (!sidebar) sidebar = column;
    }

    return sidebar;
  }

  /**
   * Runs after Boost finishes a filter render. The new vertical tree does not
   * keep ae-desktop-filters-hidden, so the show/hide toggle is applied here.
   */
  function afterRender() {
    applyDesktopFilterClass(false);
    ensureDesktopFilterButton();

    if (typeof window.aeSyncSubcollectionGrid === 'function') {
      window.aeSyncSubcollectionGrid();
    }

    // Sort/filter updates replace results in place — return to top so the sticky
    // toolbar is not left mid-page without ae-toolbar-stuck.
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, left: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });

    if (typeof window.aeSyncStickyToolbar === 'function') {
      window.aeSyncStickyToolbar();
    }
  }

  let boostAfterRenderRegistered = false;

  function registerBoostAfterRender() {
    if (boostAfterRenderRegistered) return;

    const integration = window.boostWidgetIntegration;
    if (!integration || typeof integration.regisCustomization !== 'function') return;

    integration.regisCustomization(afterRender, 'filter');
    integration.regisCustomization(afterRender);
    boostAfterRenderRegistered = true;
  }

  /**
   * @param {boolean} [deferImageFit]
   */
  function syncDesktopFilters(deferImageFit = false) {
    const sidebar = applyDesktopFilterClass(deferImageFit);

    ensureDesktopFilterButton();

    if (deferImageFit) {
      scheduleDesktopProductImageFit(sidebar);
      return;
    }

    if (desktopFilterAnimating) return;

    fitDesktopProductImages();
  }

  function replaceFilterToggleIcon() {
    const icons = document.querySelectorAll('.boost-sd__filter-tree-toggle-button-icon');

    for (const [index, icon] of icons.entries()) {
      if (!(icon instanceof HTMLElement)) continue;
      if (icon.dataset.aeIcon === 'sliders') continue;

      const clipId = `clip0_11709_12768_${index}`;
      icon.innerHTML = [
        '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon">',
        `<g clip-path="url(#${clipId})">`,
        '<path d="M0.460475 2.64889H1.85149C2.06574 3.64294 2.98349 4.40327 4.06113 4.40327C5.13877 4.40327 6.06292 3.64294 6.27397 2.64889H17.4053C17.6515 2.64889 17.8658 2.44323 17.8658 2.20017C17.8658 1.95711 17.6547 1.75145 17.4053 1.75145H6.27078C6.05653 0.757405 5.13877 -0.00292969 4.06113 -0.00292969C2.98349 -0.00292969 2.06574 0.757405 1.85149 1.75145H0.460475C0.214249 1.75145 0 1.95711 0 2.20017C0 2.44323 0.211051 2.64889 0.460475 2.64889ZM4.06113 0.894515C4.80301 0.894515 5.40419 1.48035 5.40419 2.20329C5.40419 2.92623 4.80301 3.50895 4.06113 3.50895C3.31926 3.50895 2.71808 2.92311 2.71808 2.20329C2.71808 1.48346 3.31926 0.894515 4.06113 0.894515Z" fill="black"/>',
        '<path d="M17.4053 5.98607H14.78C14.5657 4.99202 13.648 4.23169 12.5703 4.23169C11.4927 4.23169 10.5749 4.99202 10.3607 5.98607H0.460475C0.214249 5.98607 0 6.19173 0 6.43479C0 6.67785 0.211051 6.88351 0.460475 6.88351H10.3575C10.5717 7.87756 11.4895 8.63789 12.5671 8.63789C13.6448 8.63789 14.5689 7.87756 14.78 6.88351H17.4053C17.6515 6.88351 17.8658 6.67785 17.8658 6.43479C17.8658 6.19173 17.6547 5.98607 17.4053 5.98607ZM12.5671 7.74045C11.8253 7.74045 11.2241 7.15462 11.2241 6.43167C11.2241 5.70873 11.8253 5.1229 12.5671 5.1229C13.309 5.1229 13.9102 5.70873 13.9102 6.43167C13.9102 7.15462 13.309 7.74045 12.5671 7.74045Z" fill="black"/>',
        '<path d="M17.4053 10.2519H6.27078C6.05653 9.25789 5.13877 8.49756 4.06113 8.49756C2.98349 8.49756 2.08493 9.2205 1.85789 10.2177H0.460475C0.214249 10.2177 0 10.4233 0 10.7007C0 10.9406 0.211051 11.1494 0.460475 11.1494H1.85149C2.06574 12.1434 2.98349 12.9038 4.06113 12.9038C5.13877 12.9038 6.0917 12.1434 6.28357 11.1494H17.4053C17.6515 11.1494 17.8658 10.9437 17.8658 10.7007C17.8658 10.4576 17.6547 10.2519 17.4053 10.2519ZM4.06113 12.0063C3.31926 12.0063 2.71808 11.4205 2.71808 10.6975C2.71808 9.9746 3.31926 9.38877 4.06113 9.38877C4.80301 9.38877 5.40419 9.9746 5.40419 10.6975C5.40419 11.4205 4.80301 12.0063 4.06113 12.0063Z" fill="black"/>',
        '</g>',
        `<defs><clipPath id="${clipId}"><rect width="17.8626" height="12.9008" fill="white"/></clipPath></defs>`,
        '</svg>',
      ].join('');
      icon.dataset.aeIcon = 'sliders';
    }
  }

  function replaceDrawerCloseIcon() {
    const buttons = document.querySelectorAll('.boost-sd__filter-tree-vertical-mobile-toolbar .boost-sd__button--close');

    for (const button of buttons) {
      if (!(button instanceof HTMLElement)) continue;
      if (button.dataset.aeIcon === 'close') continue;

      button.innerHTML = [
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false" role="presentation">',
        '<path d="M12.9334 12.0048C12.9944 12.0658 13.0428 12.1382 13.0757 12.2178C13.1087 12.2975 13.1257 12.3829 13.1257 12.4691C13.1257 12.5553 13.1087 12.6407 13.0757 12.7204C13.0428 12.8001 12.9944 12.8724 12.9334 12.9334C12.8724 12.9944 12.8001 13.0428 12.7204 13.0757C12.6407 13.1087 12.5553 13.1257 12.4691 13.1257C12.3829 13.1257 12.2975 13.1087 12.2178 13.0757C12.1382 13.0428 12.0658 12.9944 12.0048 12.9334L6.56286 7.49064L1.12091 12.9334C0.997773 13.0566 0.83076 13.1257 0.656615 13.1257C0.48247 13.1257 0.315457 13.0566 0.192318 12.9334C0.0691788 12.8103 3.43282e-09 12.6433 0 12.4691C-3.43282e-09 12.295 0.0691788 12.128 0.192318 12.0048L5.63509 6.56286L0.192318 1.12091C0.0691788 0.997773 0 0.83076 0 0.656615C0 0.48247 0.0691788 0.315457 0.192318 0.192318C0.315457 0.0691788 0.48247 0 0.656615 0C0.83076 0 0.997773 0.0691788 1.12091 0.192318L6.56286 5.63509L12.0048 0.192318C12.128 0.0691788 12.295 -3.43282e-09 12.4691 0C12.6433 3.43282e-09 12.8103 0.0691788 12.9334 0.192318C13.0566 0.315457 13.1257 0.48247 13.1257 0.656615C13.1257 0.83076 13.0566 0.997773 12.9334 1.12091L7.49064 6.56286L12.9334 12.0048Z" fill="black"/>',
        '</svg>',
      ].join('');
      button.dataset.aeIcon = 'close';
    }
  }

  function updateMobileFilterToggle() {
    const buttons = document.querySelectorAll(TOGGLE_SELECTOR);
    if (!buttons.length) return;

    const count = getActiveFilterCount();

    for (const button of buttons) {
      const textEl = button.querySelector(TEXT_SELECTOR);
      if (!textEl) continue;

      const baseLabel = getBaseLabel(textEl);
      const nextLabel = count > 0 ? `${baseLabel} (${count})` : baseLabel;

      if (textEl.textContent.trim() !== nextLabel) {
        textEl.textContent = nextLabel;
      }

      const currentAria = button.getAttribute('aria-label') || '';
      const ariaBase = currentAria.replace(COUNT_SUFFIX_RE, '').replace(/\s+\(\d+\)$/, '').trim()
        || `Open ${baseLabel} Sidebar`;
      const nextAria = count > 0 ? `${ariaBase} (${count})` : ariaBase;

      if (button.getAttribute('aria-label') !== nextAria) {
        button.setAttribute('aria-label', nextAria);
      }

      button.dataset.activeFilterCount = String(count);
      button.classList.toggle('boost-sd__filter-tree-toggle-button--has-filters', count > 0);
    }
  }

  function updateFilterToggleCount() {
    updateFilterGroupCounts();
    updateSwatchCheckContrast();
    updateDrawerActions();
    syncDesktopFilters();
    replaceFilterToggleIcon();
    replaceDrawerCloseIcon();
    updateMobileFilterToggle();
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest('.ae-desktop-filter-toggle')) {
      if (!DESKTOP_FILTER_MQ.matches) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      desktopFiltersHidden = !desktopFiltersHidden;

      try {
        sessionStorage.setItem(DESKTOP_FILTER_STORAGE_KEY, desktopFiltersHidden ? '1' : '0');
        sessionStorage.setItem(DESKTOP_FILTER_PAGE_KEY, window.location.pathname);
      } catch (err) {}

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Pause before the sidebar class changes. Swiper's cached width is still
      // the current card width, and the first paint then scales the photo with
      // the card instead of holding the old pixel size for a frame.
      if (!reduceMotion && typeof window.setProductImageSwipersPaused === 'function') {
        window.setProductImageSwipersPaused(true);
      }

      const sidebar = applyDesktopFilterClass(!reduceMotion);
      ensureDesktopFilterButton();

      if (reduceMotion) {
        fitDesktopProductImages();
        return;
      }

      scheduleDesktopProductImageFit(sidebar);
      return;
    }

    if (!event.target.closest(TOGGLE_SELECTOR)) return;

    if (!isFilterDrawerOpen()) captureDrawerFilterState();

    updateMobileFilterToggle();
    window.setTimeout(updateMobileFilterToggle, 50);
  }, true);

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest('.ae-filter-drawer-actions__reset')) {
      event.preventDefault();
      drawerResetCommitted = true;
      drawerOpenSelectedKeys = new Set();
      drawerHistoryDelta = 0;
      restoringDrawerFilters = true;

      const clear = document.querySelector(DRAWER_CLEAR_SELECTOR);
      if (clear instanceof HTMLElement) clear.click();

      window.setTimeout(() => {
        drawerOpenHref = window.location.href;
        drawerOpenSelectedKeys = getDrawerSelectedKeys();
        drawerHistoryDelta = 0;
        drawerResetCommitted = false;
        restoringDrawerFilters = false;
        updateMobileFilterToggle();
      }, 150);
      return;
    }

    if (event.target.closest('.ae-filter-drawer-actions__apply')) {
      event.preventDefault();
      captureDrawerFilterState();
      clickDrawerClose();
      return;
    }

    if (!event.target.closest(DRAWER_CLOSE_SELECTOR)) return;

    // Apply closes by calling this button. A real X click cancels unapplied filters.
    if (event.isTrusted) {
      event.preventDefault();
      event.stopPropagation();
      cancelFilterDrawer();
      return;
    }

    updateMobileFilterToggle();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !isFilterDrawerOpen()) return;

    event.preventDefault();
    cancelFilterDrawer();
  });

  const FILTER_UI_DELAY_MS = 150;
  const FILTER_SETTLE_INTERVAL_MS = 100;
  const FILTER_SETTLE_MAX_ATTEMPTS = 40;

  let applyingFilterUi = false;
  let filterUiQueued = false;
  let filterUiTimer = 0;
  let filterSettleAttempts = 0;

  /**
   * Boost fills the visible filter lists after the titles appear.
   * Writing into the tree before that sends the values into the hidden drawer.
   * @returns {boolean}
   */
  function filtersHaveSettled() {
    return Boolean(document.querySelector('.boost-sd-left .boost-sd__filter-option-item'));
  }

  /**
   * @returns {boolean}
   */
  function filterTreeIsPresent() {
    return Boolean(document.querySelector('.boost-sd-left'));
  }

  function clearFilterUiTimer() {
    window.clearTimeout(filterUiTimer);
    filterUiTimer = 0;
  }

  function runFilterUi() {
    filterUiTimer = 0;

    if (!filtersHaveSettled()) {
      filterSettleAttempts += 1;

      if (!filterTreeIsPresent() || filterSettleAttempts >= FILTER_SETTLE_MAX_ATTEMPTS) return;

      filterUiTimer = window.setTimeout(runFilterUi, FILTER_SETTLE_INTERVAL_MS);
      return;
    }

    filterSettleAttempts = 0;
    applyingFilterUi = true;

    try {
      updateFilterToggleCount();
    } finally {
      applyingFilterUi = false;
    }

    if (!filterUiQueued) return;

    filterUiQueued = false;
    filterUiTimer = window.setTimeout(runFilterUi, FILTER_UI_DELAY_MS);
  }

  function scheduleFilterUi() {
    registerBoostAfterRender();
    syncToolbarStack();
    replaceFilterToggleIcon();
    replaceDrawerCloseIcon();
    updateMobileFilterToggle();

    if (document.querySelector('.boost-sd__filter-tree-vertical--fullWidth .boost-sd__filter-option-item')) {
      updateDrawerActions();
      updateFilterGroupCounts();
    }

    // Toolbar is on the page before filter options finish loading.
    ensureDesktopFilterButton();

    if (document.querySelector('.boost-sd__filter-option-item')) updateSwatchCheckContrast();

    if (applyingFilterUi) {
      filterUiQueued = true;
      return;
    }

    clearFilterUiTimer();

    if (!filterTreeIsPresent()) return;

    filterSettleAttempts = 0;
    filterUiTimer = window.setTimeout(runFilterUi, FILTER_UI_DELAY_MS);
  }

  function keepHiddenFiltersClosed() {
    if (!desktopFiltersHidden) return;

    document.querySelectorAll('.boost-sd-layout').forEach((layout) => {
      if (layout.classList.contains('ae-desktop-filters-hidden')) return;

      const column = layout.querySelector('.boost-sd-left');
      if (column instanceof HTMLElement) column.style.transition = 'none';
      layout.classList.add('ae-desktop-filters-hidden');
      if (!(column instanceof HTMLElement)) return;

      void column.offsetWidth;
      column.style.transition = '';
    });
  }

  const observer = new MutationObserver((mutations) => {
    keepHiddenFiltersClosed();

    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        scheduleFilterUi();
        return;
      }

      if (!(mutation.target instanceof Element)) continue;

      const className = mutation.target.className;
      if (typeof className === 'string' && className.includes('boost-sd__filter-option')) {
        scheduleFilterUi();
        return;
      }
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });

  const originalPushState = history.pushState.bind(history);
  const originalReplaceState = history.replaceState.bind(history);

  history.pushState = function pushStateWithFilterCount(...args) {
    const result = originalPushState(...args);
    keepHiddenFiltersClosed();

    if (isFilterDrawerOpen() && !restoringDrawerFilters) {
      drawerHistoryDelta += 1;
    }

    scheduleFilterUi();
    return result;
  };

  history.replaceState = function replaceStateWithFilterCount(...args) {
    const result = originalReplaceState(...args);
    keepHiddenFiltersClosed();
    scheduleFilterUi();
    return result;
  };

  window.addEventListener('popstate', scheduleFilterUi);
  window.addEventListener('pagehide', () => {
    clearFilterUiTimer();
    observer.disconnect();
  });
  registerBoostAfterRender();
  scheduleFilterUi();
})();

(() => {
  const path = window.location.pathname;
  if (!path.startsWith('/collections/')) return;

  function syncSubcollectionGrid() {
    const source = document.querySelector('.subcollection_grid:not(#subcollection_grid)');
    const target = document.querySelector('#subcollection_grid');
    if (!(source instanceof HTMLElement) || !(target instanceof HTMLElement)) return false;

    const html = source.innerHTML;
    if (!html.trim()) return false;
    if (target.innerHTML === html) {
      target.classList.add('subcollection_grid');
      return true;
    }

    target.innerHTML = html;
    target.classList.add('subcollection_grid');
    return true;
  }

  window.aeSyncSubcollectionGrid = syncSubcollectionGrid;

  if (syncSubcollectionGrid()) return;

  const observer = new MutationObserver(() => {
    if (syncSubcollectionGrid()) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => observer.disconnect(), 10000);
})();

(() => {
  // Hydrate card custom titles (.custom_display_text) from metafields or ?view=review.
  // Exposed as window.initProductCustomTitle(root, options) — same pattern as initProductImageSwipers.

  if (window.initProductCustomTitle) return;

  const BOOST_ITEM_SELECTOR = '.boost-sd__product-item, .boost-sd__suggestion-queries-item-product';
  const SHOWCASE_ITEM_SELECTOR =
    '.product-collection-showcase__card, .hero-product-showcase__card, .landing-favorites-product-card__card';
  const ITEM_SELECTOR = `${BOOST_ITEM_SELECTOR}, ${SHOWCASE_ITEM_SELECTOR}`;
  const TITLE_SELECTOR =
    '.product-collection-showcase__card-custom-title, .hero-product-showcase__card-custom-title, .landing-favorites-product-card__card-custom-title, [class*="__card-custom-title"]';
  const PRODUCT_LINK_SELECTOR =
    'a.boost-sd__product-link[href*="/products/"], a[href*="/products/"], a[class*="__card-link"][href*="/products/"]';
  const BOOST_RETRY_DELAYS = [500, 1500, 3000];

  const path = window.location.pathname;
  const isCollectionOrSearch = path.startsWith('/collections/') || path.startsWith('/search');

  const reviewCache = new Map();
  const inflight = new Map();
  let hydrateTimer = null;

  function isBoostContext(item) {
    return !!(item && item.closest && item.closest(BOOST_ITEM_SELECTOR));
  }

  function shouldHydrateItem(item) {
    if (!item || !item.matches) return false;
    if (item.matches(SHOWCASE_ITEM_SELECTOR) && isBoostContext(item)) return false;
    return item.matches(ITEM_SELECTOR);
  }

  function nodeMayContainProductItems(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches(ITEM_SELECTOR)) return true;

    if (node.classList) {
      for (let i = 0; i < node.classList.length; i++) {
        const cls = node.classList[i];
        if (cls.indexOf('boost-sd__') === 0 || cls.endsWith('__card')) return true;
      }
    }

    return !!(node.querySelector && node.querySelector(ITEM_SELECTOR));
  }

  function parseProductData(el) {
    const productData = el && el.getAttribute('data-product');
    if (!productData) return null;
    try {
      return JSON.parse(productData);
    } catch (err) {
      return null;
    }
  }

  function getProductHandle(item) {
    const titleEl = item.querySelector('[class*="__card-custom-title"][data-product-handle]');
    if (titleEl) {
      const fromTitle = normalizeProductHandle(titleEl.getAttribute('data-product-handle'));
      if (fromTitle) return fromTitle;
    }

    const directHandle = normalizeProductHandle(
      item.getAttribute('data-product-handle') || item.dataset.productHandle,
    );
    if (directHandle) return directHandle;

    const scope = item.matches(BOOST_ITEM_SELECTOR) ? item : item.closest(BOOST_ITEM_SELECTOR) || item;
    const parsed = parseProductData(scope);
    if (parsed && parsed.handle) return normalizeProductHandle(parsed.handle);

    const link = item.querySelector(PRODUCT_LINK_SELECTOR);
    if (link) {
      const match = (link.getAttribute('href') || '').match(PRODUCT_HANDLE_RE);
      if (match) return match[1];
    }

    return '';
  }

  function getProductLabelFromBoostData(item) {
    const scopes = [item];
    const boostScope = item.closest(BOOST_ITEM_SELECTOR);
    if (boostScope && boostScope !== item) scopes.push(boostScope);

    for (let i = 0; i < scopes.length; i++) {
      const parsed = parseProductData(scopes[i]);
      const metafields = parsed && parsed.metafields;
      if (!Array.isArray(metafields)) continue;

      for (let j = 0; j < metafields.length; j++) {
        const mf = metafields[j];
        if (mf && mf.namespace === 'custom' && mf.key === 'product_label' && mf.value) {
          return String(mf.value).trim();
        }
      }
    }

    return '';
  }

  function formatTitle(text) {
    if (!text) return '';
    if (typeof theme !== 'undefined' && theme.utils && theme.utils.toProperCase) {
      return theme.utils.toProperCase(text);
    }
    return text;
  }

  function applyCustomTitle(item, titleTextOrEl) {
    const container = item.querySelector(TITLE_SELECTOR);
    if (!container) return false;

    let node;
    if (titleTextOrEl && titleTextOrEl.nodeType === 1) {
      node = titleTextOrEl.cloneNode(true);
      if (node.textContent) node.textContent = formatTitle(node.textContent.trim());
    } else {
      const text = formatTitle(String(titleTextOrEl || '').trim());
      if (!text) return false;
      node = document.createElement('p');
      node.className = 'custom_display_text';
      node.textContent = text;
    }

    const displayText = (node.textContent || '').trim();
    if (!displayText) return false;

    container.innerHTML = '';
    container.appendChild(node);
    container.dataset.customTitleApplied = 'true';
    container.dataset.customTitleValue = displayText;

    if (container.hasAttribute('aria-label')) {
      container.setAttribute('aria-label', 'Collection of product is: ' + displayText);
    }

    item.dataset.customTitleHydrated = 'true';
    return true;
  }

  function fetchReviewCustomTitle(handle) {
    if (reviewCache.has(handle)) return Promise.resolve(reviewCache.get(handle));
    if (inflight.has(handle)) return inflight.get(handle);

    const request = fetch('/products/' + handle + '?view=review')
      .then((res) => res.text())
      .then((html) => {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const customTitleEl = temp.querySelector('.custom_display_text');
        reviewCache.set(handle, customTitleEl);
        inflight.delete(handle);
        return customTitleEl;
      })
      .catch(() => {
        inflight.delete(handle);
        return null;
      });

    inflight.set(handle, request);
    return request;
  }

  function hydrateCustomTitleItem(item) {
    if (!shouldHydrateItem(item)) return;

    const container = item.querySelector(TITLE_SELECTOR);
    if (!container) return;

    const inBoost = isBoostContext(item);

    // Boost renders collection names by default — always replace with metafield-aware title.
    if (!inBoost && container.dataset.customTitleApplied === 'true') return;
    if (item.dataset.customTitleHydrated === 'pending') return;

    const boostLabel = getProductLabelFromBoostData(item);
    if (boostLabel) {
      applyCustomTitle(item, boostLabel);
      return;
    }

    const handle = getProductHandle(item);
    if (!handle) return;

    if (inBoost && container.dataset.customTitleApplied === 'true') {
      const cached = reviewCache.get(handle);
      const cachedText = cached && cached.textContent ? formatTitle(cached.textContent.trim()) : '';
      if (cachedText && container.dataset.customTitleValue === cachedText) return;
    } else if (!inBoost && item.dataset.customTitleHydrated === 'true') {
      return;
    }

    item.dataset.customTitleHydrated = 'pending';

    fetchReviewCustomTitle(handle).then((customTitleEl) => {
      if (!item.isConnected) return;
      if (!customTitleEl || !applyCustomTitle(item, customTitleEl)) {
        delete item.dataset.customTitleHydrated;
      }
    });
  }

  function resetCustomTitleHydrationState(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(ITEM_SELECTOR).forEach((item) => {
      delete item.dataset.customTitleHydrated;
      const titleContainer = item.querySelector(TITLE_SELECTOR);
      if (titleContainer) {
        delete titleContainer.dataset.customTitleApplied;
        delete titleContainer.dataset.customTitleValue;
      }
    });
  }

  function initProductCustomTitle(root, options) {
    const scope = root && root.querySelectorAll ? root : document;
    if (options && options.force) {
      resetCustomTitleHydrationState(scope);
    }
    scope.querySelectorAll(ITEM_SELECTOR).forEach(hydrateCustomTitleItem);
  }

  window.initProductCustomTitle = initProductCustomTitle;
  window.initCustomTitles = initProductCustomTitle;

  function scheduleHydrate(root, options) {
    if (hydrateTimer) clearTimeout(hydrateTimer);
    hydrateTimer = setTimeout(() => {
      initProductCustomTitle(root || document, options);
    }, 150);
  }

  function runInitialHydrationPasses() {
    scheduleHydrate(document);

    if (!isCollectionOrSearch) return;

    // Boost renders PLP products asynchronously after theme scripts load.
    BOOST_RETRY_DELAYS.forEach((delay) => {
      setTimeout(() => initProductCustomTitle(document, { force: true }), delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInitialHydrationPasses);
  } else {
    runInitialHydrationPasses();
  }

  window.addEventListener('load', () => {
    if (isCollectionOrSearch) scheduleHydrate(document);
  });

  const titleObserver = new MutationObserver((mutations) => {
    let needsBatchHydrate = false;

    for (let i = 0; i < mutations.length; i++) {
      const addedNodes = mutations[i].addedNodes;
      if (!addedNodes || !addedNodes.length) continue;

      for (let j = 0; j < addedNodes.length; j++) {
        const node = addedNodes[j];
        if (node.nodeType !== 1) continue;

        if (shouldHydrateItem(node)) {
          hydrateCustomTitleItem(node);
        } else if (nodeMayContainProductItems(node)) {
          needsBatchHydrate = true;
        }
      }
    }

    if (needsBatchHydrate) scheduleHydrate(document);
  });

  titleObserver.observe(document.body, { childList: true, subtree: true });
})();

(() => {
  const path = window.location.pathname;
  if (!path.startsWith('/collections/') && !path.startsWith('/search')) return;

  const STUCK_CLASS = 'ae-toolbar-stuck';
  const SCROLLPORT_CLASS = 'ae-plp-scrollport-open';
  const root = document.documentElement;
  let frame = 0;

  const toolbarNodes = () => document.querySelectorAll('.boost-sd-layout .boost-sd__toolbar-container');

  function syncStickyToolbar() {
    const toolbars = toolbarNodes();

    for (const toolbar of toolbars) {
      if (!(toolbar instanceof HTMLElement)) continue;

      const stickyTop = Number.parseFloat(getComputedStyle(toolbar).top);
      if (!Number.isFinite(stickyTop)) {
        toolbar.classList.remove(STUCK_CLASS);
        continue;
      }

      const top = toolbar.getBoundingClientRect().top;
      const currentlyStuck = toolbar.classList.contains(STUCK_CLASS);
      const stuck = currentlyStuck ? top <= stickyTop + 8 : top <= stickyTop + 1;
      toolbar.classList.toggle(STUCK_CLASS, stuck);
    }
  }

  function requestSync() {
    if (frame) return;

    frame = window.requestAnimationFrame(() => {
      frame = 0;
      syncStickyToolbar();
    });
  }

  // Called after Boost afterRender scrolls to top so stuck styles clear immediately.
  window.aeSyncStickyToolbar = requestSync;

  window.addEventListener('scroll', requestSync, { passive: true });
  window.addEventListener('resize', requestSync);

  requestSync();

  // Overflow stays visible only for the cart drawer, including its close transition.
  // Nav and filter drawers keep the theme overflow:hidden lock. Quick Add does too.
  let cartScrollport = false;
  let scrollportQueued = false;

  const syncScrollport = () => {
    if (scrollportQueued) return;

    scrollportQueued = true;

    queueMicrotask(() => {
      scrollportQueued = false;

      const cartDrawer = document.getElementById('CartDrawer');
      const cartOpen = cartDrawer instanceof HTMLElement && cartDrawer.classList.contains('drawer--is-open');
      const htmlOpen = root.classList.contains('js-drawer-open');
      const htmlClosing = root.classList.contains('js-drawer-closing');

      if (cartOpen) cartScrollport = true;
      if (htmlOpen && !cartOpen) cartScrollport = false;
      if (!htmlOpen && !htmlClosing && !cartOpen) cartScrollport = false;

      const active = cartScrollport && (htmlOpen || htmlClosing || cartOpen);

      if (root.classList.contains(SCROLLPORT_CLASS) !== active) {
        root.classList.toggle(SCROLLPORT_CLASS, active);
      }

      releaseCartScrollIfClosed();
    });
  };

  document.addEventListener('drawerOpen', syncScrollport);

  let releaseCartScrollIfClosed = () => {};

  const scrollportObserver = new MutationObserver(syncScrollport);
  scrollportObserver.observe(root, { attributes: true, attributeFilter: ['class'] });

  // Collection and search. Stop the page behind the cart drawer.
  // Listeners ignore any event that starts inside #CartDrawer, so the cart list still scrolls.
  let cartScrollHeld = false;

  const pageScrollKeys = new Set(['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ']);

  const isInsideCart = (event) => {
    const target = event.target;
    return target instanceof Element && Boolean(target.closest('#CartDrawer'));
  };

  const blockPageScroll = (event) => {
    if (isInsideCart(event)) return;

    event.preventDefault();
  };

  const blockPageKeys = (event) => {
    if (!pageScrollKeys.has(event.key) || isInsideCart(event)) return;

    event.preventDefault();
  };

  const holdCartPageScroll = () => {
    if (cartScrollHeld) return;

    cartScrollHeld = true;
    document.addEventListener('touchmove', blockPageScroll, { passive: false });
    document.addEventListener('wheel', blockPageScroll, { passive: false });
    document.addEventListener('keydown', blockPageKeys);
  };

  const releaseCartPageScroll = () => {
    if (!cartScrollHeld) return;

    cartScrollHeld = false;
    document.removeEventListener('touchmove', blockPageScroll);
    document.removeEventListener('wheel', blockPageScroll);
    document.removeEventListener('keydown', blockPageKeys);
  };

  releaseCartScrollIfClosed = () => {
    if (!cartScrollHeld) return;
    if (root.classList.contains(SCROLLPORT_CLASS)) return;
    releaseCartPageScroll();
  };

  document.addEventListener('drawerOpen.CartDrawer', holdCartPageScroll);
})();
